import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BffUserService } from '@canvas/four-r-digital';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { environment } from '../../environments/environment';

@Component({
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
})
export class LoginComponent {
  readonly appName = environment.appName;
  readonly appShortName = environment.appShortName;

  constructor(private readonly bffService: BffUserService) {}

  login(): void {
    const { baseHRef } = environment;
    this.bffService.login(baseHRef);
  }
}
